import React, { useMemo } from 'react'
import { auditType } from '../../utils/constants/misc'
import { equalityOperators, multiselectOperators, dateOperators } from '../../utils/constants/operators'
import ListModule from '../module/ListModule'

const AuditSubModule = ({ userRight, user, location, objectType }) => {
  const columns = useMemo(
    () => [
      {
        name: 'datetime',
        label: 'Date/Heure',
        inputType: 'date',
        type: 'date',
        format: 'DD/MM/YYYY hh:mm:ss',
        isFilter: true,
        operators: dateOperators
      },
      {
        name: 'type',
        mapping: (name) => auditType.find((item) => item.name === name)?.label || name,
        label: 'Type',
        isFilter: true,
        values: auditType,
        valueEditorType: 'multiselect',
        operators: [...equalityOperators, ...multiselectOperators]
      },
      { name: 'modelType', label: 'Modèle' },
      { name: 'objectType', label: 'Objet' },
      { name: 'modification', label: 'Modifications' },
      { name: 'createdBy', label: 'Par' }
    ],
    []
  )

  const options = useMemo(
    () => ({
      objectType: 'audits',
      accessRight: userRight,
      paperStyle: { marginTop: '5px', marginBottom: '5px' },
      objectFilter: () => ({
        company_id: user?.company_id,
        objectType,
        parentId: location?.state?.id
      }),
      isExpand: false,
      columns
    }),
    [userRight, user?.company_id, objectType, location?.state?.id, columns]
  )

  const toolbar = useMemo(
    () => ({
      isSubMod: true,
      isFilter: true,
      columns,
      style: { marginTop: '5px', marginBottom: '5px' },
      objectType: 'audits',
      accessRight: userRight,
      columnVisibility: true
    }),
    [columns, userRight]
  )

  return <ListModule options={options} toolbar={toolbar} />
}

export default React.memo(AuditSubModule)
